import { ref } from 'vue';
import axios from 'axios'; // Axios veya başka bir HTTP kütüphanesi kullanabilirsiniz
const API_URL = 'https://phone360.net/api/';

export function useFetch(url) {
    const data = ref([]);
    const loading = ref(false);
    const error = ref(null);


    const token = localStorage.getItem('user');
    if (token) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${JSON.parse(token).access_token}`;
    }
    const fetchData = async () => {
               loading.value = true;
        error.value = null; // Hata durumunu sıfırla
        try {
            const response = await axios.get(API_URL+url); // API çağrısını yapın
            data.value = response.data; // Gelen veriyi data'ya ata
        } catch (err) {
            error.value = err; // Hata durumunu ata
            console.error('Veri alınırken hata oluştu:', err);
        } finally {
            loading.value = false; // Yükleniyor durumunu bitir
        }
    };

    return {
        data,
        loading,
        error,
        fetchData,
    };
}

